export const categories = [
  {
    slug: "entertainment",
    name: "娱乐圈",
    desc: "剧组、通告、颁奖礼，圈内动静第一时间跟进",
    icon: "ri-vip-crown-line",
    intro:
      "娱乐圈是瓜友会网最热闹的一块瓜田。从新剧路透到活动同框，从资源变动到番位讨论，我们把散落在各处的碎片拼成一条清晰的时间线，让你不必来回切换页面，就能看懂一件事的来龙去脉。",
  },
  {
    slug: "influencer",
    name: "网红圈",
    desc: "直播带货、账号动态、涨粉争议一站看全",
    icon: "ri-live-line",
    intro:
      "网红圈更新快、反转多。这里聚合头部主播的直播动态、账号涨跌、带货口碑与团队变动，帮你快速分辨哪些是实打实的进展，哪些只是博眼球的操作。",
  },
  {
    slug: "emotion",
    name: "情感瓜",
    desc: "恋爱、分手、CP 营业，感情线一次理清",
    icon: "ri-heart-3-line",
    intro:
      "情感瓜向来最牵动人心。我们按时间线梳理公开互动、同框细节与双方回应，把情绪化的讨论沉淀成可读的事实脉络，吃瓜也能吃得明白。",
  },
  {
    slug: "workplace",
    name: "职场瓜",
    desc: "大厂动向、团队调整、行业内幕理性围观",
    icon: "ri-briefcase-4-line",
    intro:
      "职场瓜不只是八卦，它往往反映行业的真实温度。这里聚焦组织调整、项目走向与从业者讨论，尽量还原多方视角，让围观更有参考价值。",
  },
  {
    slug: "tech",
    name: "科技圈",
    desc: "新品发布、产品争议、行业格局持续观察",
    icon: "ri-cpu-line",
    intro:
      "科技圈的瓜常常藏在发布会和参数表之外。我们关注产品口碑、生态博弈与用户真实反馈，把技术话题翻译成普通瓜友也能看懂的表达。",
  },
  {
    slug: "variety",
    name: "综艺瓜",
    desc: "节目剪辑、嘉宾互动、舞台幕后全记录",
    icon: "ri-movie-2-line",
    intro:
      "综艺瓜的乐趣在于细节。剪辑顺序、镜头分配、现场花絮都可能成为话题，我们按节目周更节奏整理热点，追综不再错过任何名场面。",
  },
];

export const heroStats = [
  { value: "12,800+", label: "累计爆料条数" },
  { value: "36", label: "覆盖圈层话题" },
  { value: "86万", label: "日活跃瓜友" },
  { value: "24h", label: "热点跟进时效" },
];

export const userVoices = [
  {
    id: "voice-01",
    name: "夜夜蹲瓜的柚子",
    role: "资深瓜友",
    avatar: "https://readdy.ai/api/search-image?query=Abstract%20flat%20avatar%20illustration%20of%20a%20friendly%20round%20face%20made%20of%20geometric%20shapes%2C%20warm%20coral%20and%20amber%20palette%2C%20cream%20background%2C%20minimal%20vector%20style%2C%20no%20text&width=120&height=120&seq=guayouhui-voice01&orientation=squarish",
    text: "最舒服的一点是这里会把时间线理清楚，同一个事件不用翻十几条动态，看完一篇就懂了前因后果。",
  },
  {
    id: "voice-02",
    name: "理性吃瓜的老陈",
    role: "圈层观察员",
    avatar: "https://readdy.ai/api/search-image?query=Abstract%20flat%20avatar%20illustration%20of%20a%20calm%20rounded%20character%20head%20with%20simple%20geometric%20features%2C%20warm%20terracotta%20and%20sand%20palette%2C%20cream%20background%2C%20minimal%20vector%20style%2C%20no%20text&width=120&height=120&seq=guayouhui-voice02&orientation=squarish",
    text: "更新很克制，不会为了热闹去夸大。有争议的地方会标出双方说法，这点在吃瓜站里挺难得的。",
  },
  {
    id: "voice-03",
    name: "追综不熬夜的可可",
    role: "综艺爱好者",
    avatar: "https://readdy.ai/api/search-image?query=Abstract%20flat%20avatar%20illustration%20of%20a%20cheerful%20rounded%20face%20with%20playful%20shapes%2C%20soft%20yellow%20and%20warm%20coral%20palette%2C%20cream%20background%2C%20minimal%20vector%20style%2C%20no%20text&width=120&height=120&seq=guayouhui-voice03&orientation=squarish",
    text: "分类做得很细，追综艺的瓜和职场瓜完全分开，不会被无关内容刷屏，找起来特别快。",
  },
];